import { useState } from 'react';
import type { CancelacionMiCita, MiCita, VistaPreviaMiCancelacion } from '../api/ops/citasCliente';
import { ErrorApi } from '../api/problema';
import { textoDeError } from './logica';

/**
 * Cancelar con el importe a la vista: se lee la vista previa al abrir, se manda con `accepted_amount` (la devolución vista)
 * y, si ha cambiado (`409 conflict`), se enseña la de ahora sin cancelar.
 */
export function useCancelacion({ leer, cancelar, onHecha, tratar }: { leer: () => Promise<VistaPreviaMiCancelacion>; cancelar: (c: CancelacionMiCita) => Promise<MiCita>; onHecha: (c: MiCita, vista: VistaPreviaMiCancelacion) => void; tratar?: (e: unknown) => boolean }) {
    const [abierta, setAbierta] = useState(false);
    const [vista, setVista] = useState<VistaPreviaMiCancelacion | null>(null);
    const [cambiada, setCambiada] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [nota, setNota] = useState('');
    const [ocupado, setOcupado] = useState(false);
    const traer = () => {
        setVista(null);
        leer()
            .then(setVista)
            .catch((e: unknown) => {
                if (tratar?.(e) !== true) setError(textoDeError(e));
            });
    };
    return {
        abierta,
        vista,
        cambiada,
        error,
        nota,
        ocupado,
        setNota,
        abrir: () => {
            setAbierta(true);
            setCambiada(false);
            setError(null);
            setNota('');
            traer();
        },
        cerrar: () => {
            if (!ocupado) setAbierta(false);
        },
        confirmar: () => {
            if (vista === null || ocupado) return;
            setOcupado(true);
            setError(null);
            cancelar({ accepted_amount: vista.refund, ...(nota.trim() === '' ? {} : { note: nota.trim() }) })
                .then((c) => {
                    setAbierta(false);
                    onHecha(c, vista);
                })
                .catch((e: unknown) => {
                    if (e instanceof ErrorApi && e.codigo === 'conflict') {
                        setCambiada(true);
                        traer();
                    } else if (tratar?.(e) !== true) {
                        setError(textoDeError(e));
                    }
                })
                .finally(() => { setOcupado(false); });
        },
    };
}
